// Sports options for dropdowns
export const SPORTS = [
  'Badminton',
  'Tennis',
  'Table Tennis',
  'Squash',
  'Basketball',
  'Football',
  'Ice Hockey',
  'Cricket',
  'Volleyball',
  'Other'
];

export const CORE_SPORTS = [
  'Badminton',
  'Football',
  'Ice Hockey',
  'Cricket',
  'Tennis',
  'Athletics',
];

export const SHOOTING_SPORTS = ['Football', 'Ice Hockey'];

export const isShootingSport = (sport?: string | null): boolean => {
  const normalized = String(sport || '').trim().toLowerCase();
  return SHOOTING_SPORTS.some((item) => item.toLowerCase() === normalized);
};

export const getRankingSubcategoriesForSport = (sport?: string | null): string[] => {
  return isShootingSport(sport) ? ['shooting', 'drills', 'fitness'] : ['strokes-shots', 'drills', 'fitness'];
};export const getDefaultRankingSubcategory = (sport?: string | null): string => {
  return getRankingSubcategoriesForSport(sport)[0];
};

export const toSportSlug = (sport?: string | null): string => {
  return encodeURIComponent(String(sport || '').trim().toLowerCase().replace(/\s+/g, '-'));
};export const toSportLabel = (value?: string | null): string => {
  const decoded = decodeURIComponent(String(value || '')).replace(/-/g, ' ').trim();
  if (!decoded) return 'Badminton';
  return decoded
    .split(/\s+/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
};
